export const createReportApi = (fetchApi) => {
  function logInfo(data) {
    return fetchApi(`/Log`, "POST", data);
  }

  return {
    logInfo,
  };
};
